import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pList, rOyakKiraBilgileriYillarWrapper, rValue } from '../../models/.catalog';

export default class OyakKiraTrGeneliYillikGelirDagilimiListeleApi extends ApiBase<
  pList,
  rValue<rOyakKiraBilgileriYillarWrapper>
> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/OyakTrGeneliYillikKiraDagilimListele',
      }),
      options
    );
  }
}
